import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Eye toggle for password boxes. usePasswordReveal() gives [inputType, toggleButton].
export function RevealButton({ shown, onToggle, testid }) {
  return (
    <button type="button" onClick={onToggle} aria-label={shown ? 'Hide password' : 'Show password'} title={shown ? 'Hide password' : 'Show password'}
      className="shrink-0 p-0.5 rounded transition-colors hover:bg-black/5" style={{ color: 'var(--olive)' }} data-testid={testid}>
      {shown ? <EyeOff size={16} /> : <Eye size={16} />}
    </button>
  );
}

export function usePasswordReveal(testid) {
  const [shown, setShown] = useState(false);
  return [shown ? 'text' : 'password', <RevealButton key={testid} shown={shown} onToggle={() => setShown((s) => !s)} testid={testid} />];
}

// Drop-in replacement for a bare <input type="password"> (wraps it with the eye inside the border).
export function PasswordInput({ className = '', style, testid, inputProps = {}, ...rest }) {
  const [type, eye] = usePasswordReveal(`${rest['data-testid'] || testid}-reveal`);
  return (
    <div className={`flex items-center gap-2 border rounded px-3 ${className}`} style={{ borderColor: 'rgba(0,0,0,0.2)', background: 'white', ...style }}>
      <input type={type} className="w-full py-2 outline-none text-sm bg-transparent" {...rest} {...inputProps} />
      {eye}
    </div>
  );
}
